<template>
  <el-input
    size="mini"
    type="text"
    v-model="tags"
    @input="onInput"
    :placeholder="suffix && suffix.placeholder || $t(placeholder)"
    @keyup.enter.native="$emit('enterEvent')"
  >
<template v-if="suffix && suffix.tag === 'span'">
  <span slot="suffix" >{{suffix.content}}</span>
</template>
</el-input>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String, null]
    },
    // 间隔符号，默认竖线，输入中英文逗号能兼容
    split: {
      type: String,
      required: false,
      default: '|'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'portal.qing-shu-ru-biao-qian-duo-ge-yong-shu-xian-ge-kai'
    },
    suffix: {
      type: Object
    }
  },
  data() {
    return {
      // 输入框里只有字符串
      tags: ''
    };
  },
  created() {
    this.tagJoin();
  },
  watch: {
    value() {
      this.tagJoin();
    }
  },
  methods: {
    tagJoin() {
      if (this.value) {
        this.tags = this.value.join(this.split);
      } else {
        this.tags = '';
      }
    },
    onInput(value) {
      const strArr = value.trim() === '' ? [] : value.replace(/，/g, ',').split(this.split);
      this.$emit('input', strArr);
    }
  }
};
</script>
